import WithRadio from '../design/WithRadio';

const LabelWithRadioButton = ({ label, labelFor, options, onChange, ...otherProps }) => {
  const orientation = 'horizontal';
  const radioId = labelFor ?? 'radio-buttons';
  return (
    <div className="flex flex-row gap-4">
      {label && (
        <div className="pt-2">
          <label htmlFor={radioId} className="font-bold">
            {label}
          </label>
        </div>
      )}
      <WithRadio id={radioId} options={options} onChange={onChange} orientation={orientation} {...otherProps} />
    </div>
  );
};

export default LabelWithRadioButton;
